"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            SSToken: null
        };
        GState.bind(this, [
            'tenant',
            'auth',
            'banner'
        ]);
        this.hasFormData = this.state.auth && !!this.state.auth.formdata;
        fhandler.bind(this, this.hasFormData && this.state.auth.formdata || {});
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'signup',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSToken = token);
    },
    onSubmit: async function (e) {
        if (!this.state.form.agree_terms || this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.first_name)
            return this.state.formError.first_name = true;
        if (!Form.last_name)
            return this.state.formError.last_name = true;
        if (!Form.email)
            return fhandler.error('email', 'Email Address field is required');
        if (!Form.password)
            return fhandler.error('password', 'Password field is required');
        Form.device = window.Device;
        this.state.submitting = true;
        try {
            const {error, message, next} = await AuthRequest('/signup', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            window.uiStore.set('email', Form.email);
            !error && fhandler.reset();
            navigate('/' + (next || 'signin'));
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    },
    onSocialSignin: function (provider) {
        if (!this.state.SSToken)
            return;
        document.location = `/${ provider }/${ this.state.SSToken }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/esemu~1.0/pages/Auth/Signup.2.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_LogoImage = require("public/images/favicon/logo.png"),
    LogoImage = module_LogoImage.default || module_LogoImage,
    module_BackgroundImg = require("public/images/backgrounds/bg-grey.svg"),
    BackgroundImg = module_BackgroundImg.default || module_BackgroundImg,
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        id: "auth-login"
      },
    marko_attrs1 = {
        "class": "col-xl-7 col-lg-9 col-12 p-2"
      },
    marko_attrs2 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_attrs3 = {
        "class": "card-body"
      },
    marko_attrs4 = {
        "class": "mx-50"
      },
    marko_attrs5 = {
        "class": "mb-4"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "form-group"
      },
    marko_attrs8 = {
        "class": "form-group"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("5ff17f"),
    marko_node0 = marko_createElement("br", null, "35", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "mb-1"
      },
    marko_node1 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "d-lg-none d-block mx-50 mt-4"
      },
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "font-medium-2"
      },
    marko_attrs12 = {
        "class": "col"
      },
    marko_attrs13 = {
        "class": "form-group"
      },
    marko_attrs14 = {
        "class": "col"
      },
    marko_attrs15 = {
        "class": "form-group"
      },
    marko_attrs16 = {
        "class": "mt-4 font-small"
      },
    marko_attrs17 = {
        "class": "mt-4 font-small"
      },
    marko_node4 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "27", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Email Address"),
    marko_node5 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "30", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Password"),
    marko_attrs18 = {
        "class": "mt-4 font-small"
      },
    marko_attrs19 = {
        "class": "checkbox checkbox-primary"
      },
    marko_node6 = marko_createElement("label", {
        "for": "agree-terms",
        "class": "font-medium-1"
      }, "39", null, 2, 0, {
        i: marko_const_nextId()
      })
      .t("I agree to the ")
      .e("a", {
          href: "/terms"
        }, null, null, 1)
        .t("terms of user & privacy policy"),
    marko_node7 = marko_createElement("p", {
        "class": "font-small-4 ml-50 mt-6"
      }, "46", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Or use social signup"),
    marko_attrs20 = {
        "class": "row m-0"
      },
    marko_attrs21 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs22 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs23 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs24 = {
        "class": "col-md-6 p-50"
      },
    marko_attrs25 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node8 = marko_createElement("img", {
        src: "/images/social/google-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "50", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node9 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "51", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Google"),
    marko_attrs26 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node10 = marko_createElement("img", {
        src: "/images/social/facebook-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "54", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node11 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "55", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Facebook"),
    marko_attrs27 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node12 = marko_createElement("img", {
        src: "/images/social/twitter-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "58", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node13 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "59", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Twitter"),
    marko_attrs28 = {
        "class": "d-flex align-items-center cursor-pointer border rounded"
      },
    marko_node14 = marko_createElement("img", {
        src: "/images/social/linkedin-icon.png",
        "class": "p-1",
        style: "width:50px"
      }, "62", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node15 = marko_createElement("div", {
        "class": "d-block w-75 text-center font-medium-1"
      }, "63", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Linkedin"),
    marko_attrs29 = {
        "class": "col-xl-7 col-lg-9 col-12 px-5 py-4"
      },
    marko_node16 = marko_createElement("div", {
        style: "margin:14rem 0",
        "class": "white-text"
      }, "78", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node17 = marko_createElement("br", null, "79", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs30 = {
        "class": "font-medium-2 font-weight-300 py-2 white-text"
      },
    marko_attrs31 = {
        "class": "position-absolute w-100 bottom-0 px-5 py-4"
      },
    marko_attrs32 = {
        "class": "list-inline m-0"
      },
    marko_attrs33 = {
        "class": "white-text"
      },
    marko_node18 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "94", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node19 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "98", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node20 = marko_createElement("li", {
        "class": "px-1 white-text"
      }, "102", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("|"),
    marko_node21 = marko_createElement("br", null, "76", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs34 = {
        "class": "font-large-2 white-text"
      },
    marko_attrs35 = {
        "class": "d-block btn btn-outline-white btn-xl text-left w-100"
      },
    marko_attrs36 = {
        "class": "d-block btn btn-outline-white btn-xl text-left w-100"
      };

const fhandler = new FormHandler({ key: 'signup-form', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        out.be("section", marko_attrs0, "1", component);

        Row_tag({
            class: "no-gutters",
            col: [
                {
                    class: "col vh-100 d-flex align-items-center justify-content-end",
                    renderBody: function(out) {
                      out.be("div", marko_attrs1, "4", component);

                      out.be("div", marko_attrs2, "5", component);

                      out.e("img", {
                          src: state.tenant ? state.tenant.logo : LogoImage,
                          style: "width:60px",
                          "class": "d-lg-none d-block rounded"
                        }, "6", component, 0);

                      if (state.auth && state.auth.message) {
                        out.n(marko_node2, component);

                        out.n(marko_node3, component);

                        out.e("p", marko_attrs11, "9", component, 1)
                          .t(state.auth.message, component);
                      }

                      out.ee();

                      out.be("div", marko_attrs3, "10", component);

                      FormAlert_tag({
                          alert: state.alert,
                          class: "mx-50"
                        }, out, __component, "11");

                      out.be("form", marko_attrs4, "@signup-form", component);

                      out.be("h5", marko_attrs5, "12", component);

                      Locale_tag({
                          text: "Sign Up"
                        }, out, __component, "13");

                      out.ee();

                      Row_tag({
                          renderBody: function(out) {
                            out.be("div", marko_attrs12, "15", component);

                            out.be("div", marko_attrs13, "16", component);

                            out.e("input", {
                                "class": "form-control form-control-xl",
                                type: "text",
                                required: true,
                                name: "first_name",
                                value: state.form.first_name,
                                placeholder: Locale("First Name*")
                              }, "17", component, 0, 0, {
                                onchange: __component.d("change", "__onChange", false)
                              });

                            if (state.formError.first_name) {
                              out.be("p", marko_attrs16, "18", component);

                              Locale_tag({
                                  renderBody: function(out) {
                                    out.t("Enter your First name");
                                  }
                                }, out, __component, "19");

                              out.ee();
                            }

                            out.ee();

                            out.ee();

                            out.be("div", marko_attrs14, "20", component);

                            out.be("div", marko_attrs15, "21", component);

                            out.e("input", {
                                "class": "form-control form-control-xl",
                                type: "text",
                                required: true,
                                name: "last_name",
                                value: state.form.last_name,
                                placeholder: Locale("Last Name*")
                              }, "22", component, 0, 0, {
                                onchange: __component.d("change", "__onChange", false)
                              });

                            if (state.formError.last_name) {
                              out.be("p", marko_attrs17, "23", component);

                              Locale_tag({
                                  renderBody: function(out) {
                                    out.t("Enter your Last name");
                                  }
                                }, out, __component, "24");

                              out.ee();
                            }

                            out.ee();

                            out.ee();
                          }
                        }, out, __component, "14");

                      out.be("div", marko_attrs6, "25", component);

                      out.e("input", {
                          "class": "form-control form-control-xl",
                          type: "email",
                          required: true,
                          name: "email",
                          value: state.form.email,
                          validate: fhandler.define("email"),
                          placeholder: Locale("Email Address*")
                        }, "26", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      if (state.formError.email) {
                        out.n(marko_node4, component);
                      }

                      out.ee();

                      out.be("div", marko_attrs7, "28", component);

                      out.e("input", {
                          "class": "form-control form-control-xl",
                          type: "password",
                          required: true,
                          name: "password",
                          value: state.form.password,
                          placeholder: Locale("Password*")
                        }, "29", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      if (state.formError.password) {
                        out.n(marko_node5, component);
                      }

                      out.ee();

                      out.be("div", marko_attrs8, "31", component);

                      out.e("input", {
                          "class": "form-control form-control-xl",
                          type: "email",
                          name: "referer",
                          disabled: component.hasFormData && (!(!state.auth.formdata.referer)),
                          value: state.form.referer,
                          validate: fhandler.define("email"),
                          placeholder: Locale("Referer Email Address")
                        }, "32", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      if (state.formError.referer) {
                        out.be("p", marko_attrs18, "33", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Enter your Last name");
                            }
                          }, out, __component, "34");

                        out.ee();
                      }

                      out.ee();

                      out.n(marko_node0, component);

                      out.e("div", marko_attrs9, "36", component, 1)
                        .e("div", marko_attrs19, "37", component, 2)
                          .e("input", {
                              type: "checkbox",
                              id: "agree-terms",
                              name: "agree_terms",
                              checked: state.form.agree_terms
                            }, "38", component, 0, 0, {
                              onchange: __component.d("change", "__onChecked", false)
                            })
                          .n(marko_node6, component);

                      out.n(marko_node1, component);

                      out.be("button", {
                          type: "submit",
                          disabled: (!state.form.agree_terms) || state.submitting,
                          "class": "btn btn-primary btn-xl text-left w-100"
                        }, "42", component, null, 0, {
                          onclick: __component.d("click", "onSubmit", false)
                        });

                      if (state.submitting) {
                        Preloader_tag({
                            class: "float-right font-medium-5",
                            active: true
                          }, out, __component, "43");
                      } else {
                        Bx_tag({
                            type: "right-arrow-alt",
                            class: "font-large-1 float-right white-text"
                          }, out, __component, "44");
                      }

                      Locale_tag({
                          text: "Continue"
                        }, out, __component, "45");

                      out.ee();

                      out.ee();

                      if ((!component.hasFormData) || (!state.auth.formdata.referer)) {
                        out.n(marko_node7, component);

                        out.e("div", marko_attrs20, "47", component, 4)
                          .e("div", marko_attrs21, "48", component, 1)
                            .e("div", marko_attrs25, "49", component, 2, 0, {
                                onclick: __component.d("click", "onSocialSignin", false, [
                                    "google"
                                  ])
                              })
                              .n(marko_node8, component)
                              .n(marko_node9, component)
                          .e("div", marko_attrs22, "52", component, 1)
                            .e("div", marko_attrs26, "53", component, 2, 0, {
                                onclick: __component.d("click", "onSocialSignin", false, [
                                    "facebook"
                                  ])
                              })
                              .n(marko_node10, component)
                              .n(marko_node11, component)
                          .e("div", marko_attrs23, "56", component, 1)
                            .e("div", marko_attrs27, "57", component, 2, 0, {
                                onclick: __component.d("click", "onSocialSignin", false, [
                                    "twitter"
                                  ])
                              })
                              .n(marko_node12, component)
                              .n(marko_node13, component)
                          .e("div", marko_attrs24, "60", component, 1)
                            .e("div", marko_attrs28, "61", component, 2, 0, {
                                onclick: __component.d("click", "onSocialSignin", false, [
                                    "linkedin"
                                  ])
                              })
                              .n(marko_node14, component)
                              .n(marko_node15, component);
                      }

                      out.be("div", marko_attrs10, "64", component);

                      if (isDefaultDomain()) {
                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Already have an institution?");
                            }
                          }, out, __component, "65");

                        out.t(" ");

                        route_link_tag({
                            href: "/",
                            class: "text-primary",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Let find it"
                                }, out, __component, "67");
                            }
                          }, out, __component, "66");
                      } else {
                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Already have an account?");
                            }
                          }, out, __component, "68");

                        out.t(" ");

                        route_link_tag({
                            href: "/signin",
                            class: "text-primary",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Sign In"
                                }, out, __component, "70");
                            }
                          }, out, __component, "69");
                      }

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  },
                {
                    class: "col p-0 d-md-flex d-none vh-100 bg-black align-items-center",
                    renderBody: function(out) {
                      out.e("div", {
                          style: marko_styleValue({
                              opacity: "0.1",
                              "background-image": ("url(\"" + (state.banner || BackgroundImg)) + "\")",
                              "background-size": "cover"
                            }),
                          "class": "position-absolute w-100 h-100"
                        }, "72", component, 0, 1);

                      out.be("div", marko_attrs29, "73", component);

                      out.e("div", null, "74", component, 3)
                        .e("img", {
                            src: (state.tenant && state.tenant.logo) || LogoImage,
                            style: "width:60px",
                            "class": "rounded-lg"
                          }, "75", component, 0)
                        .n(marko_node21, component)
                        .e("h1", marko_attrs34, "77", component, 1)
                          .t(state.tenant ? state.tenant.name : "Multipple", component);

                      out.n(marko_node16, component);

                      out.n(marko_node17, component);

                      out.be("p", marko_attrs30, "80", component);

                      if (isDefaultDomain()) {
                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Already have an institution?");
                            }
                          }, out, __component, "81");

                        out.t(" ");

                        route_link_tag({
                            href: "/",
                            class: "text-primary",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Let find it"
                                }, out, __component, "83");
                            }
                          }, out, __component, "82");
                      } else {
                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Already have an account?");
                            }
                          }, out, __component, "84");
                      }

                      out.ee();

                      if (isDefaultDomain()) {
                        out.be("button", marko_attrs35, "85", component, null, 0, {
                            onclick: __component.d("click", () => navigate('/'), false)
                          });

                        Bx_tag({
                            type: "right-arrow-alt",
                            class: "font-large-1 float-right white-text"
                          }, out, __component, "86");

                        Locale_tag({
                            text: "Let find it"
                          }, out, __component, "87");

                        out.ee();
                      } else {
                        out.be("button", marko_attrs36, "88", component, null, 0, {
                            onclick: __component.d("click", () => navigate('/signin'), false)
                          });

                        Bx_tag({
                            type: "right-arrow-alt",
                            class: "font-large-1 float-right white-text"
                          }, out, __component, "89");

                        Locale_tag({
                            text: "Sign In"
                          }, out, __component, "90");

                        out.ee();
                      }

                      out.ee();

                      out.be("div", marko_attrs31, "91", component);

                      out.be("ul", marko_attrs32, "92", component);

                      out.e("li", marko_attrs33, "93", component, 4)
                        .t("Copyright © ")
                        .t((new Date()).getFullYear(), component)
                        .t(" ")
                        .t(state.tenant ? state.tenant.name : "Multipple, Inc", component);

                      out.n(marko_node18, component);

                      out.be("li", null, "95", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Privacy Policy",
                                class: "white-text"
                              }, out, __component, "97");
                          }
                        }, out, __component, "96");

                      out.ee();

                      out.n(marko_node19, component);

                      out.be("li", null, "99", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Cookies Policy",
                                class: "white-text"
                              }, out, __component, "101");
                          }
                        }, out, __component, "100");

                      out.ee();

                      out.n(marko_node20, component);

                      out.be("li", null, "103", component);

                      route_link_tag({
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Terms",
                                class: "white-text"
                              }, out, __component, "105");
                          }
                        }, out, __component, "104");

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  }
              ]
          }, out, __component, "2");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
